// Formata o número da BR (codigoPedido) com o prefixo "BR " na frente, sem
// duplicar quando o valor salvo já vem com "BR" (ex.: usuário digitou
// "BR000157" no campo em vez de só "000157").
export const formatBR = (codigoPedido) => {
  const raw = String(codigoPedido || "").trim();
  if (!raw) return "";
  const semPrefixo = raw.replace(/^BR[\s-]*/i, "");
  return `BR ${semPrefixo}`;
};
